<template>
  <div>
    <el-dialog
      v-if="dialog_release"
      class="dialog_big_box"
      :title="langSet == 'cn' ? '发布商机' : 'Post a Business Opportunityiey'"
      :visible.sync="dialog_release"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <div class="dialog_line"></div>
        <div class="dialog_box_top">
          <div class="dialog_title_picture">
            <img :src="userInfo.avatar" alt="" />
            <img
              v-if="userInfo.exhibitor_long_id"
              src="@/assets/authentication.png"
              alt=""
            />
          </div>
          <div style="color: #ffffff">
            <div class="dialog_title_name">
              <div>{{ userInfo.nickname }}</div>
              <div>{{ userInfo._duties }}</div>
              <div class="dialog_company">{{ userInfo.companyName }}</div>
            </div>
          </div>
          <!--          <img class="dialog_edit_img" src="@/assets/edit.png" alt=""/>-->
        </div>
        <el-form
          :model="form"
          :rules="from_rules"
          label-position="top"
          label-width="auto"
          style="max-width: 600px"
        >
          <el-form-item
            :label="langSet == 'cn' ? '选择需求' : 'Select Requirements'"
            prop="status"
          >
            <el-select
              v-model="form.status"
              placeholder=""
              size="large"
              style="width: 240px"
            >
              <el-option
                v-for="item in label_list"
                :key="item.value"
                :label="langSet == 'cn' ? item.name : item.name_en"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '产品标签' : 'Product label'"
            prop="name"
          >
            <div class="tag_box">
              <div class="tag_box">
                <div
                  :class="[
                    'tag_item',
                    ProductCategory_i == index ? 'selected' : '',
                  ]"
                  v-for="(item, index) in ProductCategory"
                  :key="index"
                  @click="product_click(index, item)"
                >
                  {{ langSet == "cn" ? item.name : item.description
                  }}{{ item.layer == 1 ? (item.show ? " - " : " + ") : "" }}
                </div>
              </div>
              <div
                :class="[
                  'tag_item',
                  ProductCategory_c_i == index ? 'selected' : '',
                ]"
                v-for="(item, index) in ProductCategory_c"
                :key="index"
                @click="product_c_click(index, item)"
              >
                {{ langSet == "cn" ? item.name : item.description }}
              </div>
            </div>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '需求标签' : 'Requirement label'"
            prop="name"
          >
            <div class="tag_box">
              <div
                :class="['tag_item', item.selected ? 'selected' : '']"
                v-for="(item, index) in NeedLabel"
                :key="index"
                @click="tag_item_click(index, item)"
              >
                {{ langSet == "cn" ? item.labelName : item.en_labelName }}
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-if="form.status == 3"
            :label="langSet == 'cn' ? '选择可洽谈时间' : 'Negotiation time'"
            prop="talk_time"
          >
            <el-date-picker
              v-model="form.talk_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="
                langSet == 'cn' ? '选择日期时间' : 'Negotiation time'
              "
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '所在机构类型' : 'Type of organization'"
            prop="organization_id"
          >
            <el-select
              v-model="form.organization_id"
              placeholder=""
              size="large"
              style="width: 240px"
            >
              <el-option
                v-for="item in OrganizationLabel"
                :key="item.id"
                :label="langSet == 'cn' ? item.labelName : item.en_labelName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="
              langSet == 'cn'
                ? '上传图片（最多三张）'
                : 'Upload images (up to three)'
            "
            prop="fileList"
          >
            <!--            v-if="publication_type==1"-->
            <el-upload
              :action="$Url + '/pc/Upload/image'"
              :headers="headers"
              list-type="picture-card"
              :on-success="handleLogoSuccess"
              :on-error="handleLogoError"
              :on-remove="handleRemove"
              :on-preview="handlePreview"
              :file-list="fileList"
              :limit="3"
              :on-exceed="handleExceed"
              :before-upload="beforeUpload"
              style="display: flex"
              :class="{ 'hide-upload': fileList.length >= 3 }"
            >
              <i v-if="fileList.length < 3" class="el-icon-plus"></i>

              <!-- 修复预览功能的模板 -->
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <!--            <div v-if="form.fileList.length<3" class="image_list">-->
            <!--             <div class="item_image" v-for="(item,index) in form.fileList" :key="index">-->
            <!--               <el-image :src="item">-->
            <!--                 <div class="upload-span">-->
            <!--                   <span class="upload-icon" @click.stop="handlePictureCardPreview($imgUrl+license_pic)"><i class="el-icon-zoom-in"></i></span>-->
            <!--                   <span class="upload-icon" @click.stop="handleRemove()" style="margin-left: 20px"><i class="el-icon-delete"></i></span>-->
            <!--                 </div>-->
            <!--               </el-image>-->
            <!--             </div>-->
            <!--            </div>-->
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '需求描述' : 'Requirement'"
            prop="description"
          >
            <el-input
              type="textarea"
              :rows="7"
              resize="none"
              :placeholder="
                langSet == 'cn'
                  ? '请详细描述您的需求'
                  : 'Please provide a detailed description of your requirements'
              "
              v-model="form.description"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span class="dialog-footer">
        <!--    <el-button @click="dialogVisible = false">取 消</el-button>-->
        <el-button class="dialog_submit" v-prevent-re-click type="primary" @click="submit">{{
          langSet == "cn" ? "提 交" : "Submit"
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>


<script>
import {
  business_publish_add,
  getNeedLabel,
  getOrganizationLabel,
} from "@/api/business_api";
import { getLinkage } from "@/api/api";

export default {
  name: "dialog_release",
  props: ["publication_type", "options", "dialog_release", "label_value"],
  data() {
    return {
      langSet: "",
      dialogVisible: false,
      form: {
        status: "",
        description: "",
        talk_time: "",
        fileList: [],
      },
      from_rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      dialogImageUrl: "",
      disabled: false,
      headers: {
        token: localStorage.getItem("token"),
      },
      fileList: [],
      label_list: [
        {
          name: "我提供产品或资源",
          name_en: "Suppliers",
          value: "1",
        },
        {
          name: "我寻找产品或资源",
          name_en: "Demands",
          value: "2",
        },
        {
          name: "海外-我寻找产品或货源",
          name_en: "Overseas Procurements",
          value: "3",
        },
      ],
      NeedLabel: [], //需求标签
      OrganizationLabel: [], //机构类型
      ProductCategory: [], //产品类别
      ProductCategory_c: [], //产品类别
      ProductCategory_i: null, //
      ProductCategory_c_i: null, //
    };
  },
  mounted() {
    this.langSet = this.$language;
    this.form.status = this.publication_type;
    this.getNeedLabel();
    this.getOrganizationLabel();
    this.get_Linkage();
  },
  methods: {
    // 获取需求标签
    async getNeedLabel() {
      const res = await getNeedLabel();
      this.NeedLabel = res.data.lists;
      this.NeedLabel.forEach((item) => {
        item.selected = false;
      });
    },
    // 产品类别
    async get_Linkage() {
      const res = await getLinkage({ keyid: 3360 });
      let list = res.data[3360];
      list.forEach((item) => {
        item.show = false;
        item.layer = 1;
      });
      this.ProductCategory = list;
    },
    // 机构类型
    async getOrganizationLabel() {
      const res = await getOrganizationLabel();
      this.OrganizationLabel = res.data.lists;
    },
    // 上传成功处理
    handleLogoSuccess(response, file, fileList) {
      this.fileList = fileList;
      this.$message.success("图片上传成功");
    },
    // 上传失败处理
    handleLogoError(err, file, fileList) {
      this.$message.error("图片上传失败");
      console.error("上传错误:", err);
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => file.url != item.url);
    },

    // 预览图片
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 超出数量限制提示
    handleExceed() {
      this.$message.warning("最多只能上传3张图片");
    },
    // 上传前校验
    beforeUpload(file) {
      const isImage = file.type.includes("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("只能上传图片格式!");
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
      }

      return isImage && isLt2M;
    },
    tag_item_click(index, item) {
      this.NeedLabel[index].selected = !this.NeedLabel[index].selected;
      this.NeedLabel = [...this.NeedLabel];
    },
    product_click(index, item) {
      this.ProductCategory_i = index;
      this.ProductCategory_c_i = null;
      this.ProductCategory_c = item.children;
      this.ProductCategory.forEach((item, item_index) => {
        item.show = index == item_index;
      });
    },
    product_c_click(index, item) {
      this.ProductCategory_c_i = index;
    },
    async submit() {
      let fileArr = [];
      this.fileList.forEach((item) => {
        fileArr.push(item.response.data.uri);
      });
      let label_idstr = [];
      this.NeedLabel.forEach((item, index) => {
        if (item.selected) {
          label_idstr.push(item.id);
        }
      });
      if (
        this.form.status.length == 0 ||
        this.ProductCategory_c_i.length == 0 ||
        label_idstr.length == 0 ||
        fileArr.length == 0 ||
        this.form.description.length == 0 ||
        (this.form.status == 3 && this.form.talk_time.length == 0)
      )
        return this.$message.error("请将信息填写完整");
      let data = {
        status: this.form.status, //需求类型（1-供应类 2-需求类 3-海外采购类
        company_label_1: this.ProductCategory[this.ProductCategory_i].linkageid, //一级产品标签
        company_label_2:
          this.ProductCategory_c[this.ProductCategory_c_i].linkageid, //二级产品标签
        label_idstr: label_idstr.join(","), //需求标签
        organization_id: this.form.organization_id, //机构类型
        imgs: fileArr, //需求图片
        description: this.form.description, //需求描述
        talk_time: this.form.talk_time, //洽谈时间
      };
      const res = await business_publish_add(data);
      this.$message.success(res.msg);
      this.form = {};
      this.fileList = [];
      this.ProductCategory_i = null; //
      this.ProductCategory_c_i = null; //
      this.getNeedLabel();
      this.handleClose();
    },
    handleClose() {
      this.$emit("add_round", true);
    },
  },
};
</script>


<style scoped lang="scss">
/deep/ .el-select {
  width: 100% !important;
}

/deep/ .el-date-editor {
  width: 100% !important;
}

//弹窗
.dialog_big_box {
  /deep/ .el-dialog {
    width: 525px !important;
    height: auto !important;
    background: #ffffff;
    border-radius: 20px;
    position: relative;
  }

  .dialog-footer {
    //position: absolute;
    display: flex;
    justify-content: center;
    //margin: 30px;
  }

  /deep/ .el-dialog__body {
    padding: 0 30px 30px 30px !important;
  }

  .dialog_line {
    width: 100%;
    border-bottom: 1px solid #f3f3f3;
  }

  .dialog_box_top {
    position: relative;
    display: flex;
    padding: 10px;
    align-items: center;
    height: 110px;
    background: #f7f8fa;
    border-radius: 8px;
    margin: 20px 0 15px 0;
  }

  .dialog_title_picture {
    position: relative;
    margin-right: 10px;
  }

  .dialog_title_picture > img:first-child {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .dialog_title_picture > img:nth-child(2) {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .dialog_title_name {
    //display: flex;
    margin-bottom: 5px;
    align-items: center;
    margin-left: 10px;
  }

  .dialog_title_name > div:nth-child(1) {
    margin-bottom: 3px;
    font-weight: 500;
    font-size: 20px;
    color: #001a33;
    line-height: 30px;
    letter-spacing: 1px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_title_name > div:nth-child(2) {
    margin-bottom: 3px;
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_company {
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: left;
    font-style: normal;
  }

  .dialog_edit_img {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }

  .tag_box {
    display: flex;
    flex-wrap: wrap;
  }

  .tag_item {
    //overflow: hidden;
    //white-space: nowrap;
    //text-overflow: ellipsis;
    cursor: pointer;
    box-sizing: border-box;
    //width: calc((100% - 30px) / 3);
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #cad2dd;
    margin: 0 15px 15px 0;
    color: #888888;
    //&:nth-child(3n) {
    //  margin-right: 0;
    //}
  }

  .selected {
    background: #1d2379;
    color: #ffffff;
  }

  .dialog_footer {
  }

  .dialog_submit {
    width: 180px;
    height: 42px;
    border-radius: 9px;
    background-color: #004190;
    border-color: #004190;
  }

  .dialog_submit:hover {
    background-color: #004190;
    opacity: 0.9;
  }

  .dialog_submit:focus {
    background-color: #004190;
    opacity: 1;
  }

  /deep/ .el-form-item__label {
    line-height: 14px;
  }

  /* 隐藏上传按钮 */
  .hide-upload ::v-deep .el-upload--picture-card {
    display: none;
  }

  /deep/ .el-upload-list__item {
    width: 97px;
    height: 97px;
  }

  /deep/ .el-upload--picture-card {
    width: 97px;
    height: 97px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  //.image_list{
  //  display: flex;
  //  align-items: center;
  //
  //  .item_image{
  //    width: 97px;
  //    height: 97px;
  //  }
  //  .el-image{
  //    width: 97px;
  //    height: 97px;
  //    position: relative;
  //    .upload-span{
  //      position: absolute;
  //      z-index: 99;
  //      top: 0;
  //      left: 0;
  //    }
  //  }
  //
  //}
}

@media only screen and (max-width: 767px) {
  .dialog_big_box {
    /deep/ .el-dialog {
      width: 6.54rem !important;
      height: auto !important;
      background: #ffffff;
      border-radius: 0.38rem;
    }

    /deep/ .el-dialog__body {
      padding: 0 0.29rem 0.29rem 0.29rem !important;
    }
  }
}
</style>